// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles_panel__1_rRg"};